import { Accordion } from 'react-bootstrap';
import React from 'react';
import { FeedbackLevel } from '../../../../interfaces/FeedbackLevel';
import EvaluationInput from '../EvaluationInput';
import { IEvaluationRequirement } from '../../../../interfaces/IApplicationRequirements';
import IRankingsPair from '../../../../interfaces/IRankingsPair';

interface Props {
    value?: any;
    onChange: (name: string, value: any) => void;
    readOnly?: boolean;
    handleFeedback: (level: FeedbackLevel, message: string) => void;
    req: IEvaluationRequirement;
    isAlgorithm: boolean;
}

const AccordionItem: React.FC<Props> = ({
    value,
    onChange,
    readOnly = false,
    handleFeedback,
    req,
    isAlgorithm,
}) => {
    const sectionComplete = value?.complete || false;
    const sectionValue = value?.value;

    const handleChange = (change: { value: string | IRankingsPair; complete: boolean }) => {
        onChange(req.name, change);
    };

    return (
        <Accordion.Item eventKey={req.name} className={'bg-transparent'}>
            <Accordion.Header>
                {req.title}{' '}
                {sectionComplete && (
                    <i
                        className={'bi bi-check2-circle ms-2 fs-4'}
                        title={`${req.title} complete`}
                    />
                )}
            </Accordion.Header>
            <Accordion.Body className={'text-black'}>
                <EvaluationInput
                    isAlgorithm={isAlgorithm}
                    readOnly={readOnly}
                    req={req}
                    inputValue={sectionValue}
                    inputComplete={sectionComplete}
                    onChange={handleChange}
                    onFeedback={handleFeedback}
                    minLength={req.minLength || 1}
                    maxLength={req.maxLength}
                />
            </Accordion.Body>
        </Accordion.Item>
    );
};

export default AccordionItem;
